import { render, staticRenderFns } from "./Supply.vue?vue&type=template&id=627b014f&"
import script from "./Supply.vue?vue&type=script&lang=js&"
export * from "./Supply.vue?vue&type=script&lang=js&"
import style0 from "./Supply.vue?vue&type=style&index=0&id=627b014f&prod&lang=scss&"
import style1 from "./Supply.vue?vue&type=style&index=1&id=627b014f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports